













import { defineComponent, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'AppToggleButton',
  props: {
    text: {
      type: String,
      default: '',
    },
    fill: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const labelStyle = computed(() => {
      return props.fill
        ? {
            color: 'white',
            backgroundColor: 'var(--red-500)',
            borderColor: 'var(--red-500)',
          }
        : {
            color: 'var(--red-500)',
            backgroundColor: 'transparent',
            borderColor: 'var(--red-500)',
          }
    })

    return { labelStyle }
  },
})
